import React from 'react';

const CTASection = () => {
  return (
    <section id="contact" className="py-24 bg-emerald-500 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-400 rounded-full filter blur-3xl opacity-50"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-600 rounded-full filter blur-3xl opacity-50"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Transform Your Production?
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Get a personalized quote from Malta's official Redsail distributor and discover how our laser machines can boost your business efficiency.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:+35699446552"
            className="group px-8 py-4 bg-white text-emerald-600 font-semibold rounded-full hover:bg-gray-100 transition-all shadow-xl shadow-emerald-600/20 flex items-center justify-center gap-2 whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl" aria-hidden="true"></i>
            Call Us Now
          </a>
          <a
            href="https://wa.me/35699446552"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-emerald-600 text-white font-semibold rounded-full hover:bg-emerald-700 transition-all flex items-center justify-center gap-2 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl" aria-hidden="true"></i>
            WhatsApp Us
          </a>
        </div>

        <p className="text-white/80 text-sm mt-8">
          <i className="ri-time-line mr-1" aria-hidden="true"></i>
          Response within 2 business hours
        </p>
      </div>
    </section>
  );
};

export default CTASection;
